/**
 * @fileoverview Routes du portail citoyen GNPC.
 *
 * La page 404 est branchée deux fois, volontairement :
 *   - en route catch-all (`path: '*'`) À L'INTÉRIEUR du layout, pour que le
 *     citoyen égaré garde le header et le footer du portail ;
 *   - en `errorElement` de la route racine, pour couvrir les erreurs de rendu
 *     inattendues (le layout étant lui-même en erreur, la page s'affiche
 *     alors seule).
 */

import { createBrowserRouter } from 'react-router-dom';
import { PortalLayout } from './layouts/PortalLayout.tsx';
import { GoodToKnowPage } from './pages/GoodToKnowPage.tsx';
import { HistoryPage } from './pages/HistoryPage.tsx';
import { LoginPage } from './pages/LoginPage.tsx';
import { NotFoundPage } from './pages/NotFoundPage.tsx';
import { PaymentPage } from './pages/PaymentPage.tsx';
import { PaymentReturnPage } from './pages/PaymentReturnPage.tsx';
import { SearchPage } from './pages/SearchPage.tsx';
import { SupportPage } from './pages/SupportPage.tsx';

export const router: ReturnType<typeof createBrowserRouter> = createBrowserRouter([
  {
    path: '/',
    element: <PortalLayout />,
    errorElement: <NotFoundPage />,
    children: [
      { index: true, element: <LoginPage /> },
      { path: 'recherche', element: <SearchPage /> },
      { path: 'bon-a-savoir', element: <GoodToKnowPage /> },
      { path: 'paiement', element: <PaymentPage /> },
      { path: 'paiement/retour', element: <PaymentReturnPage /> },
      { path: 'historique', element: <HistoryPage /> },
      { path: 'assistance', element: <SupportPage /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
]);
